export const regexValidation = {
  trim: /^(?! )/,
  vatNumber: /^\d{15}$/g,
  numberWithMaxSixDecimals: /^[0-9]+\.?[0-9]{0,6}$|^\.?[0-9]{0,6}$/g,
};
